<div>
    <div class="mb-4" v-if="!hasNoFilter">
        <h4>Filter By</h4>
        <slot name="filter"></slot>
        <div class="row mt-3">
            <div class="col-6">
                <slot name="actionButton"></slot>
            </div>
            <div class="col-6">
                <button class="btn btn-primary float-right" @click="onFilterSearchClick">Search</button>
            </div>
        </div>
        <!--        <div class="pb-4 w-100">-->
        <!--            <button class="btn btn-primary float-right" @click="onFilterSearchClick">Search</button>-->
        <!--        </div>-->
    </div>
    <!--    <hr v-if="!hasNoFilter">-->
    <div :class="{'disabled-overlay': stateChanged}">
        <div class="table-responsive">
            <table class="table table-hover mb-0">
                <thead>
                <tr>
                    <th v-for="(heading, i) in tableHeadings" :key="i">
                        {{ heading.text }}
                    </th>
                    <th v-if="showActions"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in tableData" :key="index" :class="{'pendingOrderBackground': item[fieldToDetermineColumnColor] === 'Yes' }">
                    <td v-for="(field, itemIndex) in tableHeadings" :key="itemIndex">
                        {{ item[field.field]}}
                    </td>
                    <td v-if="item.actions !== null && item.actions !== undefined && showActions">
                        <div class="dropdown" id="actionDropdownDataTable">
                            <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"
                                    :disabled="stateChanged">
                                Action
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenu1" id="actionDropdownDataTableMenu">
                                <div v-for="(action, actionIndex) in item.actions" >
                                    <button class="dropdown-item"
                                            @click="onActionItemClicked(item, action.key)"
                                            v-if="action.elementId"
                                            :id="action.elementId + '_' + index">
                                        {{ action.name }}
                                    </button>
                                    <button class="dropdown-item"
                                            @click="onActionItemClicked(item, action.key)"
                                            v-if="action.elementId === undefined || action.elementId === null || action.elementId === ''">
                                        {{ action.name }}
                                    </button>
                                </div>


                            </div>
                        </div>
                    </td>
                    <td v-if="(hasCustomActionComponent && hasActions) && (item.actions === null || item.actions === undefined)">
                        <slot name="actionComponent" v-bind="item"></slot>
                    </td>
                </tr>
                </tbody>
            </table>
            <slot name="content"></slot>
        </div>

        <div class="row mt-3" id="paginationControls" v-if="(tableData !== null && tableData.length > 0) && (!hasNoPaging)">
            <div class="col-4 text-left">
                <button id="previousButton" class="btn btn-primary waves-effect waves-light"
                        :disabled="pagingInfo.pageNumber === 1 || stateChanged"
                        @click="previousPage">
                    <i class="fa fa-arrow-left"></i> Previous
                </button>
            </div>
            <div class="col-4 text-center paginationPageNumbering">
                    <span>
                        <input type="number" class="pageNumber-textbox" v-model="pagingInfo.pageNumber" @input="onPageNumberInput" @blur="onPageNumberBlur" v-if="!increasePagingWidth"
                               :disabled="stateChanged"/>
                        <input type="number" class="pageNumber-textbox-large" v-model="pagingInfo.pageNumber" @input="onPageNumberInput" @blur="onPageNumberBlur" v-if="increasePagingWidth"
                               :disabled="stateChanged"/>
                    </span>
                /
                <span id="totalPages">{{pagingInfo.totalPages}}</span>
            </div>
            <div class="col-4 text-right">
                <button id="nextButton" class="btn btn-primary waves-effect waves-light"
                        :disabled="pagingInfo.pageNumber === pagingInfo.totalPages || stateChanged"
                        @click="nextPage">
                    Next <i class="fa fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

